import styled from "styled-components";

export const UnsetTypesList = styled.ul`
  margin: 0.5rem 0 0 1.3rem;
`;
